<footer class="sts-footer sts-object">

  <div class="container-fluid">

    <div class="row haha">
      <div *ngIf="footerModel.logo" class="col-7">
        <div class="foot-hyperlinks-compartment">
          <a href="/"
             [innerHtml]="footerModel.logo | stsSafeHtml" tabindex="-1">
          </a>
        </div>

        <div class="logo footer-left-section" *ngIf="footerModel.socialLinks && footerModel.socialLinks.length > 0">
          <div class="foot-link-compartment social-link-compartment">
            <a
              class="social-link"
              href="{{item.href}}"
              (click)="socialLinkClick(item)"
              [target]="item.target"
              *ngFor="let item of footerModel.socialLinks; let i = index"
              title="{{item.title}}">

              <div *ngIf="item.image; else showIcon" [innerHTML]="item.image"></div>
              <ng-template #showIcon>
                <i class="{{item.cssClass}} animate-all"></i>
              </ng-template>
            </a>
          </div>
        </div>
      </div>
      <app-sts-bs-dialog [(visible)]="showDialog" [(item)]="dialogueItem">
        <iframe id="iframeAbout" [src]="getCurrentLink() | stsSafeUrl" width="100%" class="dialog-iframe" frameborder="0" sandbox="allow-same-origin allow-scripts"></iframe>
      </app-sts-bs-dialog>

      <div class="footer-link-wrapper">
        <div class="foot-link-compartment foot-hyperlinks-compartment">
          <a class="footer-link"
             href="#"
             (click)="click(item)"
             *ngFor="let item of footerModel.links; let i = index"
             [innerHtml]="item.title | stsSafeHtml">
          </a>
        </div>
      </div>

    </div>

  </div>


</footer>
